class MFooter extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      if (MinimogTheme.config.mqlMobile) {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
        this.enableAccordionKeyboard(mobileAccordion);
      }
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
        this.enableAccordionKeyboard(mobileAccordion);
      });
      document.addEventListener("unmatchMobile", () => {
        this.disableAccordionKeyboard(mobileAccordion);
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      document.addEventListener("matchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
      document.addEventListener("unmatchMobile", () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      });
    }
  }

  enableAccordionKeyboard(root) {
    root.querySelectorAll(".m-accordion--item-button").forEach((btn) => {
      btn.setAttribute("role", "button");
      btn.setAttribute("tabindex", "0");
      if (!btn._a11yKeydown) {
        btn._a11yKeydown = (e) => {
          if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            btn.click();
          }
        };
        btn.addEventListener("keydown", btn._a11yKeydown);
      }
    });
  }

  disableAccordionKeyboard(root) {
    root.querySelectorAll(".m-accordion--item-button").forEach((btn) => {
      btn.removeAttribute("role");
      btn.removeAttribute("tabindex");
    });
  }
}
customElements.define("m-footer", MFooter);
